import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import isEmail from "validator/lib/isEmail";
import * as yup from "yup";

import useYupValidation from "../../../../../../../hooks/useYupValidation";
import { APIConfigEmail } from "../../../../../../../models/api.config.email";
import { Input } from "../../../../../../../components/Form";
import Modal from "../../../../../../../components/Generic/Modal";
import useStyles from "./styles";

type ModalToInviteSistrsProps = {
  configEmail?: APIConfigEmail;
  isOpen: boolean;
  onClose: (configEmail?: APIConfigEmail) => void;
};

export const ModalToInviteSistrs = (props: ModalToInviteSistrsProps) => {
  const { configEmail, isOpen, onClose } = props;
  const { t: translate } = useTranslation();

  const classes = useStyles();

  const [configEmailUpdated, setConfigEmailUpdated] = useState<APIConfigEmail>();

  const [errors, setErrors] = useState<yup.ValidationError[]>([]);

  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  const { fieldHasError, getErrorByField } = useYupValidation(errors);

  useEffect(() => {
    if (configEmail) setConfigEmailUpdated(configEmail);
  }, [configEmail]);

  useEffect(() => {
    if (isSubmitted) validate();
  }, [configEmailUpdated?.email]);

  const onSubmit = () => {
    setIsSubmitted(true);
    if (validate()) onClose(configEmailUpdated);
  };

  const validate = () => {
    try {
      const schema = yup.object().shape({
        email: yup
          .string()
          .required(translate("thisFieldIsRequired"))
          .test({
            name: "validate-email",
            message: translate("thisEmailIsInvalid"),
            test: (value) => {
              return isEmail(value || "");
            },
          }),
      });

      schema.validateSync(
        {
          email: configEmailUpdated?.email,
        },
        { abortEarly: false }
      );

      setErrors([]);

      return true;
    } catch (error) {
      if (error instanceof yup.ValidationError) {
        setErrors(error?.inner);
      }

      return false;
    }
  };

  return (
    <Modal
      title={configEmail ? translate("editSISTR") : translate("inviteSISTR")}
      open={isOpen}
      className={classes.modalWidth}
      showActionButtons
      actionButtonProps={{
        textSave: configEmail ? translate("editSISTR") : translate("inviteSISTR"),
        onSave: onSubmit,
        dataCySave: "save-sistrs",
      }}
      handleClose={() => onClose()}
    >
      <Input
        fullWidth
        label={translate("SISTRemail")}
        autoComplete="off"
        name="email"
        data-cy="email-sistr"
        placeholder="sales@shipeezi.com"
        error={fieldHasError("email")}
        errorMessage={getErrorByField("email")}
        value={configEmailUpdated?.email || ""}
        type="email"
        onKeyDown={(event) => {
          if (event.key && event.key.toLowerCase().trim() === "enter") onSubmit();
        }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setConfigEmailUpdated({ ...(configEmailUpdated || {}), email: event.target.value })
        }
      />
    </Modal>
  );
};
